import Vue from 'vue'
import Router from 'vue-router'
import { config } from './utils'

Vue.use(Router)

const routes = new Router({
  routes: [
    { path: '/', component: () => import('@/views/Home') },
    { path: '/changelog/:project', component: () => import('@/views/ChangeLog') },
    { path: '/dialog/', component: () => import('@/views/v-dialogs/Home') },
    { path: '/dialog/demo', component: () => import('@/views/v-dialogs/Demo') },
    { path: '/page', component: () => import('@/views/v-page/Home') },
    { path: '/page/demo', component: () => import('@/views/v-page/Demo') },
    { path: '/upload', component: () => import('@/views/v-uploader/Home') },
    { path: '/upload/demo', component: () => import('@/views/v-uploader/Demo') },
    { path: '/region', component: () => import('@/views/v-region/Home') },
    { path: '/region/demo', component: () => import('@/views/v-region/Demo') },
    { path: '/selectpage', component: () => import('@/views/v-selectpage/Home') },
    { path: '/selectpage/demo', component: () => import('@/views/v-selectpage/Demo') },
    { path: '/suggest', component: () => import('@/views/v-suggest/Home') },
    { path: '/suggest/demo', component: () => import('@/views/v-suggest/Demo') },
    { path: '/playback', component: () => import('@/views/v-playback/Home') },
    { path: '/playback/demo', component: () => import('@/views/v-playback/Demo') },
    { path: '/selectmenu', component: () => import('@/views/v-selectmenu/Home') },
    { path: '/selectmenu/demo', component: () => import('@/views/v-selectmenu/Demo') },
    { path: '/gallery', component: () => import('@/views/v-gallery/Home') },
    { path: '/gallery/demo', component: () => import('@/views/v-gallery/Demo') }
  ]
})

config(routes)

export default routes
